import type {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {AthleteDomainModel} from "../../common/athlete/athlete-domain-model";
import {CompetitorDomainModel} from "../../common/competitor/models/competitor-domain-model";
import {BaseDomainDataSource} from "../../../infrastructure/models/base-domain-data-source";
import {SearchResponseApiModel} from "./search-response-api-model";

export class SearchDataSource extends BaseDomainDataSource {
  competitions: Array<CompetitionDomainModel>;
  competitors: Array<CompetitorDomainModel>;
  athletes: Array<AthleteDomainModel>;
  shouldBlockScrolling: Boolean;

  constructor(
    apiModel: SearchResponseApiModel,
    competitions: Array<CompetitionDomainModel>,
    competitors: Array<CompetitorDomainModel>,
    athletes: Array<AthleteDomainModel>,
    shouldBlockScrolling: Boolean = true
  ) {
    super(apiModel);

    this.competitions = competitions;
    this.competitors = competitors;
    this.athletes = athletes;
    this.shouldBlockScrolling = shouldBlockScrolling;
  }
}
